/**
 * Chování tabule úkolů (Kanban.registerBehaviour("tasks")): práce s úkolem
 * přímo na kartě bez otevírání detailu – název upravíte kliknutím, ostatní
 * (popis, termín, řešitelé, štítky, barva, dokončenost, komentář) v jednom
 * plovoucím panelu u karty. Štítky nabízí naposledy použité jedním klikem
 * a hledání s možností založit nový.
 */
(function ($) {
    "use strict";

    if (!window.Kanban) {
        return;
    }

    var $panel = null;
    var panelCleanup = null;

    function esc(value) {
        return window.escapeHtml ? window.escapeHtml(value) : $("<div>").text(value == null ? "" : value).html();
    }

    /** Stejný vzorec jako TagsModel::textColorFor – světlé pozadí => černé písmo. */
    function isLight(hex) {
        var value = String(hex).replace("#", "");
        if (value.length !== 6) {
            return false;
        }
        var r = parseInt(value.substr(0, 2), 16);
        var g = parseInt(value.substr(2, 2), 16);
        var b = parseInt(value.substr(4, 2), 16);
        return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5;
    }

    function t(board, key) {
        var texts = board.config.extra.texts || {};
        return texts[key] || key;
    }

    // ------------------------------------------------------------------ panel

    function closePanel() {
        if (panelCleanup) {
            panelCleanup();
            panelCleanup = null;
        }
        if ($panel) {
            $panel.remove();
            $panel = null;
        }
        $(document).off(".kbPanel");
    }

    /** Plovoucí panel u prvku karty; onOpen dostane panel, vrací volitelný úklid. */
    function openPanel($anchor, title, bodyHtml, onOpen) {
        closePanel();
        $panel = $('<div class="kb-panel" role="dialog"></div>')
            .append($('<div class="kb-panel-title"></div>').text(title))
            .append(bodyHtml)
            .appendTo(document.body);

        var rect = $anchor[0].getBoundingClientRect();
        var left = Math.min(rect.left + window.scrollX, window.scrollX + document.documentElement.clientWidth - $panel.outerWidth() - 16);
        $panel.css({ top: rect.bottom + window.scrollY + 6, left: Math.max(8, left) });

        panelCleanup = onOpen ? onOpen($panel) : null;

        setTimeout(function () {
            $(document).on("mousedown.kbPanel touchstart.kbPanel", function (e) {
                if ($panel && !$(e.target).closest(".kb-panel, .select2-container, .select2-dropdown").length) {
                    closePanel();
                }
            });
            $(document).on("keydown.kbPanel", function (e) {
                if (e.key === "Escape") {
                    closePanel();
                }
            });
        }, 0);

        var $focus = $panel.find("[autofocus]").first();
        if ($focus.length) {
            $focus.trigger("focus");
        }
        return $panel;
    }

    function actionsHtml(board) {
        return '<div class="kb-panel-actions">' +
            '<button type="button" class="btn btn-sm btn-light" data-panel-cancel>' + esc(board.t("cancel")) + "</button>" +
            '<button type="button" class="btn btn-sm btn-info" data-panel-save>' + esc(board.t("save")) + "</button>" +
            "</div>";
    }

    /** Panel s formulářem: Uložit zavolá save(panel) → promise operace. */
    function formPanel(board, $anchor, title, bodyHtml, save, onOpen) {
        openPanel($anchor, title, bodyHtml + actionsHtml(board), function ($p) {
            $p.on("click", "[data-panel-cancel]", closePanel);
            $p.on("click", "[data-panel-save]", function () {
                var $save = $(this);
                if ($save.prop("disabled")) {
                    return;
                }
                var request = save($p);
                if (request) {
                    // dvojklik nesmí odeslat operaci dvakrát (např. dva stejné komentáře)
                    $save.prop("disabled", true);
                    request.done(closePanel).fail(function () {
                        $save.prop("disabled", false);
                    });
                }
            });
            $p.on("keydown", "input", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    $p.find("[data-panel-save]").trigger("click");
                }
            });
            return onOpen ? onOpen($p) : null;
        });
    }

    /** Plné hodnoty úkolu (karta ukazuje zkrácený popis). */
    function loadFields(board, id) {
        return board.request("op", { op: "fields", id: id, payload: {} })
            .then(function (response) {
                return response.data;
            })
            .fail(function (message) {
                // úkol mezitím smazaný / chyba sítě – editor se neotevře, ať to uživatel ví
                board.toastError(message);
            });
    }

    // ------------------------------------------------------------- jednotlivé akce

    function editTitle(board, $card) {
        var $title = $card.find(".kb-title");
        if ($title.find("input").length) {
            return;
        }
        var original = $title.text();
        var $input = $('<input type="text" class="form-control form-control-sm kb-title-input" maxlength="255">').val(original);
        $title.empty().append($input);
        $input.trigger("focus").trigger("select");

        var done = false;
        function finish(save) {
            if (done) {
                return;
            }
            done = true;
            var value = $.trim($input.val());
            if (!save || value === "" || value === original) {
                $title.text(original);
                return;
            }
            $title.text(value);
            board.op($card.data("id"), "rename", { nazev: value }).fail(function () {
                $title.text(original);
            });
        }

        $input.on("keydown", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                finish(true);
            } else if (e.key === "Escape") {
                finish(false);
            }
        });
        $input.on("blur", function () {
            finish(true);
        });
    }

    function editDescription(board, $card, $anchor) {
        var id = $card.data("id");
        loadFields(board, id).done(function (fields) {
            formPanel(board, $anchor, t(board, "editDescription"),
                '<textarea class="form-control" rows="6" autofocus data-field="ukol"></textarea>',
                function ($p) {
                    return board.op(id, "describe", { ukol: $p.find('[data-field="ukol"]').val() });
                },
                function ($p) {
                    $p.find('[data-field="ukol"]').val(fields.ukol).trigger("focus");
                });
        });
    }

    function editDeadline(board, $card, $anchor) {
        var id = $card.data("id");
        loadFields(board, id).done(function (fields) {
            var date = fields.konec ? fields.konec.substr(0, 10) : "";
            var time = fields.konec && !fields.isFullDay ? fields.konec.substr(11, 5) : "";
            formPanel(board, $anchor, t(board, "deadline"),
                '<label class="kb-hint mb-1">' + esc(t(board, "date")) + "</label>" +
                '<input type="date" class="form-control form-control-sm mb-2" data-field="date" autofocus>' +
                '<label class="kb-hint mb-1">' + esc(t(board, "time")) + "</label>" +
                '<input type="time" class="form-control form-control-sm" data-field="time">' +
                '<div class="kb-hint mt-1">' + esc(t(board, "allDayHint")) + "</div>",
                function ($p) {
                    var newDate = $p.find('[data-field="date"]').val();
                    if (!newDate) {
                        board.toastError(t(board, "deadlineRequired"));
                        return null;
                    }
                    return board.op(id, "deadline", { date: newDate, time: $p.find('[data-field="time"]').val() });
                },
                function ($p) {
                    $p.find('[data-field="date"]').val(date);
                    $p.find('[data-field="time"]').val(time);
                });
        });
    }

    function userOptions(board, selectedIds) {
        return $.map(board.config.extra.users, function (user) {
            var selected = selectedIds.indexOf(user.id) !== -1 ? " selected" : "";
            return '<option value="' + user.id + '"' + selected + ">" + esc(user.name) + "</option>";
        }).join("");
    }

    function editSolvers(board, $card, $anchor) {
        var id = $card.data("id");
        loadFields(board, id).done(function (fields) {
            formPanel(board, $anchor, t(board, "solvers"),
                '<select multiple class="form-control" data-field="solvers">' + userOptions(board, fields.solverIds) + "</select>",
                function ($p) {
                    var ids = $.map($p.find('[data-field="solvers"]').val() || [], function (v) {
                        return parseInt(v, 10);
                    });
                    return board.op(id, "solvers", { userIds: ids });
                },
                function ($p) {
                    var $select = $p.find('[data-field="solvers"]');
                    $select.select2({ dropdownParent: $p, width: "100%", placeholder: t(board, "solversHint") });
                    return function () {
                        $select.select2("destroy");
                    };
                });
        });
    }

    function tagChipHtml(tag) {
        return '<button type="button" class="kb-panel-chip" data-tag-id="' + tag.id + '" style="background-color:' + esc(tag.color) +
            ";color:" + esc(tag.textColor) + '">' + esc(tag.name) + "</button>";
    }

    function editTags(board, $card, $anchor) {
        var id = $card.data("id");
        var extra = board.config.extra;
        var onCard = $card.find(".kb-tag-remove").map(function () {
            return $(this).data("tag-id");
        }).get();

        var recent = $.grep(extra.recentTagIds || [], function (tagId) {
            return onCard.indexOf(tagId) === -1 && extra.tags[tagId];
        });
        var chips = $.map(recent, function (tagId) {
            return tagChipHtml(extra.tags[tagId]);
        }).join("");

        var options = $.map(extra.tags, function (tag) {
            return onCard.indexOf(tag.id) === -1 ? '<option value="' + tag.id + '">' + esc(tag.name) + "</option>" : null;
        }).join("");

        var body = (chips ? '<div class="kb-hint mb-1">' + esc(t(board, "tagsRecent")) + '</div><div class="kb-panel-chips">' + chips + "</div>" : "") +
            '<select class="form-control" data-field="tag"><option></option>' + options + "</select>" +
            (options || chips ? "" : '<div class="kb-hint mt-1">' + esc(t(board, "tagsEmpty")) + "</div>");

        function rememberTag(tag) {
            extra.tags[tag.id] = tag;
            extra.recentTagIds = [tag.id].concat($.grep(extra.recentTagIds || [], function (tagId) {
                return tagId !== tag.id;
            }));
        }

        /** Druhý krok pro správce štítků: barva nového štítku z palety týmu. */
        function pickNewTagColor(name) {
            var swatches = $.map(extra.tagPalette || [], function (hex) {
                return '<button type="button" class="kb-color-option" data-color="' + esc(hex) + '" title="' + esc(hex) +
                    '" aria-label="' + esc(hex) + '" style="background-color:' + esc(hex) + '"></button>';
            }).join("");
            var preview = '<div class="mb-2"><span class="kb-panel-chip" data-tag-preview>' + esc(name) + "</span></div>";

            openPanel($anchor, t(board, "tagColor"), preview + '<div class="kb-colors">' + swatches + "</div>", function ($p) {
                $p.on("mouseenter focus", ".kb-color-option", function () {
                    var hex = $(this).data("color");
                    $p.find("[data-tag-preview]").css({ backgroundColor: hex, color: isLight(hex) ? "#000" : "#fff" });
                });
                $p.on("click", ".kb-color-option", function () {
                    addTag({ name: name, color: $(this).data("color") });
                });
                $p.find(".kb-color-option").first().trigger("mouseenter").trigger("focus");
            });
        }

        function addTag(payload) {
            closePanel();
            board.op(id, "addTag", payload).done(function (response) {
                if (response.data && response.data.tag) {
                    rememberTag(response.data.tag);
                }
            });
        }

        openPanel($anchor, t(board, "tags"), body, function ($p) {
            $p.on("click", ".kb-panel-chip", function () {
                addTag({ tagId: $(this).data("tag-id") });
            });

            var $select = $p.find('[data-field="tag"]');
            $select.select2({
                dropdownParent: $p,
                width: "100%",
                tags: true,
                placeholder: t(board, "tagsPlaceholder"),
                createTag: function (params) {
                    var term = $.trim(params.term);
                    return term === "" ? null : { id: "new:" + term, text: term, newTag: true };
                },
            });
            $select.on("select2:select", function (e) {
                var data = e.params.data;
                if (data.newTag || String(data.id).indexOf("new:") === 0) {
                    if (extra.canPickTagColor) {
                        // panel se přestaví až po dokončení select2 události
                        setTimeout(function () {
                            pickNewTagColor(data.text);
                        }, 0);
                    } else {
                        addTag({ name: data.text });
                    }
                } else {
                    addTag({ tagId: parseInt(data.id, 10) });
                }
            });
            // Rovnou otevřít hledání a dát do něj kurzor (jinak zůstane fokus na
            // tlačítku karty a psaní nikam nevede). Panel mohl být mezitím zavřen.
            setTimeout(function () {
                if (!$select.data("select2")) {
                    return;
                }
                $select.select2("open");
                // nativní focus – jQuery trigger("focus") select2 handlery pohltí
                var search = $select.data("select2").$dropdown.find(".select2-search__field")[0];
                if (search) {
                    search.focus();
                }
            }, 0);
            return function () {
                if ($select.data("select2")) {
                    $select.select2("destroy");
                }
            };
        });
    }

    function editColor(board, $card, $anchor) {
        var id = $card.data("id");
        var swatches = $.map(board.config.extra.colors, function (color) {
            return '<button type="button" class="kb-color-option" data-color="' + color.id + '" title="' + esc(color.name) +
                '" aria-label="' + esc(color.name) + '" style="background-color:' + esc(color.hex) + '"></button>';
        }).join("");

        openPanel($anchor, t(board, "color"), '<div class="kb-colors">' + swatches + "</div>", function ($p) {
            $p.on("click", ".kb-color-option", function () {
                var color = $(this).data("color");
                closePanel();
                board.op(id, "color", { color: color });
            });
        });
    }

    function editCompletion(board, $card, $anchor) {
        var id = $card.data("id");
        loadFields(board, id).done(function (fields) {
            formPanel(board, $anchor, t(board, "completion"),
                '<div class="d-flex align-items-center" style="gap:.5rem">' +
                '<input type="range" class="custom-range" min="0" max="100" step="10" data-field="completion">' +
                '<span class="kb-hint" data-completion-label style="min-width:3rem;text-align:right"></span></div>',
                function ($p) {
                    return board.op(id, "completion", { completion: parseInt($p.find('[data-field="completion"]').val(), 10) });
                },
                function ($p) {
                    var $range = $p.find('[data-field="completion"]');
                    var $label = $p.find("[data-completion-label]");
                    $range.on("input", function () {
                        $label.text($range.val() + " %");
                    }).val(fields.completion).trigger("input");
                });
        });
    }

    function addComment(board, $card, $anchor) {
        var id = $card.data("id");
        formPanel(board, $anchor, t(board, "comment"),
            '<textarea class="form-control" rows="4" maxlength="5000" autofocus data-field="text" placeholder="' + esc(t(board, "commentPlaceholder")) + '"></textarea>',
            function ($p) {
                var text = $.trim($p.find('[data-field="text"]').val());
                if (!text) {
                    return null;
                }
                return board.op(id, "comment", { text: text }).done(function () {
                    if (typeof window.flashMessage === "function") {
                        window.flashMessage(t(board, "commentSaved"), "g");
                    }
                });
            });
    }

    function deleteTask(board, $card) {
        var id = $card.data("id");
        var confirmed = window.Swal
            ? Swal.fire({
                title: board.t("confirmDelete"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: board.t("yes"),
                cancelButtonText: board.t("no"),
            }).then(function (result) {
                return !!result.value;
            })
            : Promise.resolve(window.confirm(board.t("confirmDelete")));

        confirmed.then(function (ok) {
            if (ok) {
                board.op(id, "delete", {});
            }
        });
    }

    // --------------------------------------------------------- rychlé přidání

    function quickAdd(board, $column) {
        var $list = $column.find(".kb-list");
        if ($column.find(".kb-quick-add").length) {
            $column.find(".kb-quick-add input:first").trigger("focus");
            return;
        }
        var lane = $list.data("lane");
        var today = new Date();
        var todayIso = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2);
        var isColleagues = lane === "colleagues";

        var $form = $('<form class="kb-quick-add" autocomplete="off"></form>').html(
            '<input type="text" class="form-control form-control-sm" maxlength="255" required data-field="nazev" placeholder="' + esc(t(board, "quickAddName")) + '">' +
            '<div class="d-flex" style="gap:.4rem">' +
            '<input type="date" class="form-control form-control-sm" required data-field="date" value="' + todayIso + '">' +
            '<input type="time" class="form-control form-control-sm" data-field="time" title="' + esc(t(board, "time")) + '">' +
            "</div>" +
            (isColleagues ? '<select multiple class="form-control form-control-sm" data-field="userIds">' + userOptions(board, []) + "</select>" : "") +
            '<div class="kb-panel-actions">' +
            '<button type="button" class="btn btn-sm btn-light" data-quick-cancel>' + esc(board.t("cancel")) + "</button>" +
            '<button type="submit" class="btn btn-sm btn-info">' + esc(t(board, "quickAddSubmit")) + "</button>" +
            "</div>"
        );
        $list.before($form);
        if (isColleagues) {
            $form.find('[data-field="userIds"]').select2({ width: "100%", placeholder: t(board, "solversHint") });
        }
        $form.find('[data-field="nazev"]').trigger("focus");

        function remove() {
            var $select = $form.find('[data-field="userIds"]');
            if ($select.data("select2")) {
                $select.select2("destroy");
            }
            $form.remove();
        }

        $form.on("click", "[data-quick-cancel]", remove);
        $form.on("keydown", function (e) {
            if (e.key === "Escape") {
                remove();
            }
        });
        $form.on("submit", function (e) {
            e.preventDefault();
            var name = $.trim($form.find('[data-field="nazev"]').val());
            if (!name) {
                return;
            }
            var payload = {
                lane: lane,
                column: $list.data("column"),
                nazev: name,
                date: $form.find('[data-field="date"]').val(),
                time: $form.find('[data-field="time"]').val(),
            };
            if (isColleagues) {
                payload.userIds = $.map($form.find('[data-field="userIds"]').val() || [], function (v) {
                    return parseInt(v, 10);
                });
            }
            var $submit = $form.find('[type="submit"]').prop("disabled", true);
            board.request("op", { op: "create", id: 0, payload: payload })
                .done(function (response) {
                    board.applyResponse(response);
                    if (response.data && response.data.notice && typeof window.flashMessage === "function") {
                        window.flashMessage(response.data.notice, "g");
                    }
                    $form.find('[data-field="nazev"]').val("").trigger("focus");
                })
                .fail(function (message) {
                    board.toastError(message);
                })
                .always(function () {
                    $submit.prop("disabled", false);
                });
        });
    }

    // ---------------------------------------------------------------- napojení

    window.Kanban.registerBehaviour("tasks", function (board) {
        board.payloadBuilders = {
            toggleDone: function ($el) {
                return { done: String($el.data("done")) === "1" };
            },
            removeTag: function ($el) {
                return { tagId: $el.data("tag-id") };
            },
        };

        var actions = {
            rename: editTitle,
            describe: editDescription,
            deadline: editDeadline,
            solvers: editSolvers,
            tags: editTags,
            color: editColor,
            completion: editCompletion,
            comment: addComment,
            delete: deleteTask,
        };

        board.$root.on("click", "[data-kb-action]", function (e) {
            var action = $(this).data("kb-action");
            if (action === "quickAdd") {
                e.preventDefault();
                quickAdd(board, $(this).closest(".kb-column"));
                return;
            }
            var $card = $(this).closest(".kb-card");
            if (!actions[action] || !$card.length) {
                return;
            }
            e.preventDefault();
            // akce z menu "…" se ukotví na kartu, ostatní na kliknutý prvek
            var $anchor = $(this).closest(".dropdown-menu").length ? $card : $(this);
            actions[action](board, $card, $anchor);
        });

        board.$root.on("click", "[data-kb-board-op]", function (e) {
            e.preventDefault();
            board.request("op", { op: $(this).data("kb-board-op"), id: 0, payload: {} })
                .done(function () {
                    window.location.reload();
                })
                .fail(function (message) {
                    board.toastError(message);
                });
        });

        // Datumový filtr nad tabulí (stejný jako v seznamu úkolů).
        board.$root.on("submit", "[data-kb-date-filter]", function (e) {
            e.preventDefault();
            var $form = $(this);
            if ($form.data("pending")) {
                return;
            }
            $form.data("pending", true);
            board.request("op", {
                op: "setDateFilter",
                id: 0,
                payload: { from: $form.find('[name="from"]').val(), to: $form.find('[name="to"]').val() },
            })
                .done(function () {
                    window.location.reload();
                })
                .fail(function (message) {
                    $form.data("pending", false);
                    board.toastError(message);
                });
        });
    });
})(jQuery);
